var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dice",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dice__d10",
    d: "M 4.5 0.5 L 8 3.5 L 8 5.5 L 4.5 8.5 L 1 5.5 L 1 3.5 L 4.5 0.5 L 8 3.5 M 4.5 0.5 L 6.5 5 L 4.5 5.5 L 2.5 5 L 4.5 0.5 M 8 5.5 L 6.5 5 M 1 5.5 L 2.5 5 M 4.5 5.5 L 4.5 8.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD10);
export default __webpack_public_path__ + "static/media/d10.cd30e8bae4a587c093f50c4d34b8dad8.svg";
export { ForwardRef as ReactComponent };